import {AnimFade} from "./turbo27_extanims";
import {madnes_scale_to, madnes_alpha_to} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_anim_add_oncomplete_once, madnes_anim_play, madnes_show_money,
    madnes_start_coin,
    madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_audio_loop, madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {show_bigwin_label} from "./turbo27_reels";
import {
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_get_scale_x,
    madnes_get_scale_y, madnes_get_texture, madnes_get_visible,
    madnes_set_alpha, madnes_set_pos, madnes_set_scale, madnes_set_texture,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    freespins,
    big_win,
    fps,
    in_free_spins,
    mega_win,
    set_in_free_spins,
    super_win,
    wi, madnes_objects
} from "../framework/src/engine/madnes/madnes_variables";
import {bet, madnes_money_to_coin, madnes_set_win} from "../framework/src/engine/madnes/madnes";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    anim_add_fs,
    control_freespins,
    get_jokers_from_symbols,
    get_orig_sprite_name, get_symbol_name,
    get_symbols_from_winset, hide_all_winline_rings, hide_winline, set_symbol_center,
    show_winline
} from "./turbo27_core_res_ctrl";
import {AnimBlink, AnimScale} from "./turbo27_extanims";
import {cylinder_pos} from "./adapters/madnesGameAdapter";
import {fade_in_reels_bg, fade_out_reels_bg} from "./turbo27_core_printer";
import {fsTotal} from "./turbo27_core_res_ctrl";

var money_add_big_win_anim_step = 0;
var money_add_big_win_add_to_render;

/**
 * @param {number} won
 * @param {boolean=} from_freespin
 * @returns {Promise}
 */
export function money_add_big_win_anim(won, from_freespin)
{

    //setTimeout(function() {
    madnes_audio_play("audio_bw");
    //}, 50);

    if(from_freespin) {
        show_bigwin_label("bonus_label");
    } else {
        show_bigwin_label("bigwin_label");
    }

    madnes_set_alpha("bigwin_bg", 0);
    madnes_set_visible("bigwin_bg", true);
    madnes_fade_in("bigwin_bg", 100);

    return new Promise(function(res) {

        var bigWinCounter = new BigWinCounter(madnes_money_to_coin(won), bet, [big_win * bet, mega_win * bet, super_win * bet]);

        bigWinCounter.onMegaWin(function() {
            (!from_freespin) && show_bigwin_label('megawin_label');
        });

        bigWinCounter.onSuperWin(function() {
            (!from_freespin) && show_bigwin_label('supermegawin_label');
        });

        bigWinCounter.onUpdate(function(val) {
            windesk_setsum(Math.round(val));
            //madnes_set_text("bigwin_text", Math.round(val));
        });

        bigWinCounter.run().then(res);

        madnes_audio_loop('remittance_A');

    }).then(function() {
        return new Promise(function(res) {

            madnes_audio_stop('remittance_A');
            madnes_audio_play("remittance_B");

            setTimeout(madnes_stop_coin, won < 1000 ? 2000 : 1000);

            setTimeout(function() {
                windesk_hide();
                res();
            }, 2500);

        });
    });
}

/*var money_add_big_win_add_pos = 0;
var money_add_big_win_add_max = 0;
var money_add_big_win_add_step = -1;
function money_add_big_win_add(from_freespin)
{
	var tmp_add = Math.round( money_add_big_win_add_max * ( Math.random() / 100 ) );
	if(tmp_add < 1)
	{
		tmp_add = 1;
	}
	money_add_big_win_add_pos = money_add_big_win_add_pos * 1 + tmp_add;

	if(money_add_big_win_add_step == -1) {
		madnes_audio_loop('remittance_A');
		money_add_big_win_add_step = 0;
	}

	if(money_add_big_win_add_step == 0 && money_add_big_win_add_pos > bet * mega_win && !from_freespin)
	{
		//money_add_big_win_add_pos = bet * mega_win;
		money_add_big_win_add_step = 1;

		(!from_freespin) && show_bigwin_label('megawin_label');
	}
	else if(money_add_big_win_add_step == 1 && money_add_big_win_add_pos > bet * super_win)
	{
		//money_add_big_win_add_pos = bet * super_win;
		money_add_big_win_add_step = 2;

		(!from_freespin) && show_bigwin_label('supermegawin_label');

	}

	if(money_add_big_win_add_pos > money_add_big_win_add_max)
	{

		madnes_audio_stop('remittance_A');
		madnes_audio_play("remittance_B");

		money_add_big_win_add_pos = money_add_big_win_add_max;

		madnes_rem_from_render(money_add_big_win_add_to_render);
		money_add_big_win_anim_step = 2;

		if(money_add_big_win_add_max < 100) {
			setTimeout(function() {
				madnes_stop_coin();
			}, 2000);
		}
		else
		{
			madnes_stop_coin();
		}

		setTimeout(money_add_big_win_anim.bind(this, money_add_big_win_add_max, from_freespin), 3000);
	}

	windesk_setsum(money_add_big_win_add_pos);
}*/

var windesk_setsum_buffer = new Array()
function windesk_setsum(sum)
{
    madnes_set_visible('windesk_sum', true);
    madnes_set_text('windesk_sum', sum);
}

function windesk_hide()
{
    /*if(false && madnes_get_visible('bonuswin'))
    {
        madnes_fade_out('bonuswin', 600, 0, function() {
            madnes_set_alpha('bonuswin', 1);
            madnes_set_visible('bonuswin', false);
        });
    }
    else
    {*/
    madnes_fade_out('bigwin_bg', 600, 0, function() {
        madnes_set_alpha('bigwin_bg', 1);
        madnes_set_visible('bigwin_bg', false);
    });
    //}

    madnes_fade_out('windesk_sum', 600, 0, function() {
        madnes_set_alpha('windesk_sum', 1);
        madnes_set_visible('windesk_sum', false);
    });
}

var freespin_state = new Array();

function madnes_fade_out(name, duration, delay, cb)
{
    if(delay == 'undefined' || !delay) {
        delay = 0;
    }

    setTimeout(madnes_alpha_to.bind(this, name, 0, duration, cb), delay);
}

/**
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @param {Function=} cb
 */
function madnes_fade_in(name, duration, delay, cb)
{
    if(delay == 'undefined' || !delay) {
        delay = 0;
    }

    setTimeout(madnes_alpha_to.bind(this, name, 1, duration, cb), delay);
}

function madnes_anim_pulse(name, xScale, yScale, duration, delay, cb)
{

    var origScaleX = madnes_get_scale_x(name);
    var origScaleY = madnes_get_scale_y(name);

    setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration), delay);
    setTimeout(madnes_scale_to.bind(this, name, origScaleX, origScaleY, duration), duration + delay, cb);
}

export function madnes_anim_scale(name, xScale, yScale, duration, delay, callback)
{
    setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration, callback), delay);
}

function madnes_anim_blink(name, count, duration, callback)
{
    setTimeout(function() {

        madnes_set_visible(name, !madnes_get_visible(name));

        if(count >= 0) {
            madnes_anim_blink(name, --count, duration, callback);
        } else {
            if(typeof callback == 'function') {
                callback();
            }
        }
    }, duration);
}

export function anim_win_line(win_set)
{
    return new Promise(function(resolve) {

        /*var animSymbols = [];
        var jokers = [];
        //var winSetSymbolName = get_symbol_name(winsetSymbolIndex);

        for(var pos in win_set.position) {

            var xPos = win_set.position[pos][0];
            var yPos = win_set.position[pos][1];
            var yPosS = 2 - yPos;

            var symbolIndex = server_result.result.reelMatrix[0][xPos][yPos];
            var symbObj = {
                'spriteName': "reels_bufer_" + xPos + "_S" + yPosS,
                'x': xPos,
                'y': yPosS,
                'isJoker': (get_symbol_name(symbolIndex) == "symbol_Joker")
            };

            animSymbols.push(symbObj);

            if(symbObj['isJoker'])
            {
                jokers.push(symbObj);
            }

            //madnes_set_cstm_val(symbObj['spriteName'], get_symbol_on_position(xPos, yPos));
        }*/

        var symbols = get_symbols_from_winset(win_set);
        var jokers = get_jokers_from_symbols(symbols);
        var winsetLine = win_set['line'];
        var winsetSymbolIndex = win_set['symbol'];


        anim_add_frames(symbols, winsetLine).then(function() {
            return anim_set_tmp_symbols(symbols);
        }).then(function() {
            return anim_fade_out_jokers(jokers);
        }).then(function() {
            return anim_switch_jokers(jokers, winsetSymbolIndex);
        }).then(function() {
            return anim_fade_in_symbols(jokers);
        }).then(function() {
            return anim_scale_symbols("in", symbols, 1.2, 1.2, 200, 0);
        }).then(function() {
            return anim_scale_symbols("out", symbols, 1, 1, 200, 1000);
        }).then(function() {
            return anim_hide_tmp_symbols(symbols);
        }).then(function() {
            return anim_remove_frames(symbols, winsetLine);
        }).then(function() {
            return resolve();
        });

    });
}

function anim_set_tmp_symbols(symbols)
{
    return new Promise(function(resolve) {
        for(var i = 0; i < symbols.length; i++) {

            var symX = symbols[i]['x'];
            var symY = symbols[i]['y'];

            var x = madnes_get_pos_x(symbols[i]['spriteName']);
            var y = madnes_get_pos_y(symbols[i]['spriteName']);

            var origName = get_orig_sprite_name(symbols[i]['spriteName']);
            var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;

            madnes_set_texture(tmpSpriteName, origName);
            madnes_set_pos(tmpSpriteName, x, y, true);
            madnes_set_visible(tmpSpriteName, true);
        }

        resolve();
    });
}

function anim_hide_tmp_symbols(symbols)
{
    return new Promise(function(resolve) {
        for(var i = 0; i < symbols.length; i++) {

            var symX = symbols[i]['x'];
            var symY = symbols[i]['y'];
            var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;

            madnes_set_pos(tmpSpriteName, -9999, -9999);
            madnes_set_visible(tmpSpriteName, false);
        }

        resolve();
    });
}

function anim_add_frames(symbols, line)
{
    show_winline(line);

    return new Promise(function(resolve) {
        for(var i = 0; i < symbols.length; i++) {
            var x = madnes_get_pos_x(symbols[i]['spriteName']) - 28;
            var y = madnes_get_pos_y(symbols[i]['spriteName']) - 18;

            var symX = symbols[i]['x'];
            var symY = symbols[i]['y'];

            madnes_set_pos("winframe_" + symX + "_" + symY, x, y);
            madnes_set_visible("winframe_" + symX + "_" + symY, true);
        }

        resolve();
    });
}

function anim_remove_frames(symbols, line)
{
    hide_winline(line);
    hide_all_winline_rings();

    return new Promise(function(resolve) {
        for(var i = 0; i < symbols.length; i++) {

            var symX = symbols[i]['x'];
            var symY = symbols[i]['y'];

            madnes_set_pos("winframe_" + symX + "_" + symY, -9999, -9999);
            madnes_set_visible("winframe_" + symX + "_" + symY, false);
        }

        resolve();
    });
}

function anim_scale_symbols(type, symbols, scaleX, scaleY, duration, delay)
{
    return new Promise(function(resolve)
    {
        for(var i = 0; i < symbols.length; i++)
        {
            var symX = symbols[i]['x'];
            var symY = symbols[i]['y'];

            var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;

            if(type == "in") {
                set_symbol_center(tmpSpriteName);
            }

            var scaleSymbol = new AnimScale(tmpSpriteName, scaleX, scaleY, duration, delay);
            scaleSymbol.run().then(function() {
                resolve();
            });
        }
    });
}

function anim_fade_out_jokers(jokers)
{
    return new Promise(function(resolve) {
        if(jokers.length > 0) {

            for(var i = 0; i < jokers.length; i++) {
                //var symX = jokers[i].x;
                //var symY = jokers[i].y;
                //var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;
            }

            resolve();
        }
        else
        {
            resolve();
        }
    });
}

function anim_switch_jokers(jokers, toSymbolIndex)
{
    return new Promise(function(resolve) {

        if(jokers.length > 0) {
            for(var i = 0; i < jokers.length; i++) {

                var symX = jokers[i]['x'];
                var symY = jokers[i]['y'];
                var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;

                madnes_set_texture(tmpSpriteName, get_symbol_name(toSymbolIndex));
            }
        }

        resolve();
    });
}

function anim_fade_in_symbols(jokers)
{
    return new Promise(function(resolve) {
        if(jokers.length > 0) {
            for(var i = 0; i < jokers.length; i++) {

                var symX = jokers[i]['x'];
                var symY = jokers[i]['y'];
                var tmpSpriteName = "reels_bufer_" + symX + "_TMP" + symY;

                //var jokerFadeIn = new AnimFade("in", tmpSpriteName, 100);
                //jokerFadeIn.run().then(resolve);
                madnes_set_visible(tmpSpriteName, true);
                madnes_set_alpha(tmpSpriteName, 1);
            }
        }

        resolve();
    });

}

export function anim_winx2()
{
    return new Promise(function(resolve) {

        var symbols = [];

        for(var i = 0; i < cylinder_pos.length; i++) {
            for(var y = 0; y < 3; y++) {

                var xPos = i;
                var yPos = y;
                var yPosS = 2 - yPos;

                //var symbolIndex = server_result.result.reelMatrix[0][xPos][yPos];
                var symbObj = {
                    'spriteName': "reels_bufer_" + xPos + "_S" + yPosS,
                    'x': xPos,
                    'y': yPosS
                };

                symbols.push(symbObj);
            }
        }

        setTimeout(function() {
            anim_winx2_blink(symbols, 4000);
        }, 200);

        madnes_audio_play("win_x2");

        madnes_set_visible("winx2_label", true);
        madnes_set_alpha("winx2_label", 0);

        new AnimFade("in", "winx2_label", 300).run().then(function() {

            return new Promise(function(res) {
                setTimeout(function() {
                    res();
                }, 4000);
            });

        }).then(function() {
            return new AnimFade("out", "winx2_label", 400).run();
        }).then(function() {
            madnes_set_visible("winx2_label", false);
            resolve();
        });
    });
}

function anim_winx2_blink(symbols, duration)
{
    return new Promise(function(resolve) {

        for(var i = 0; i < symbols.length; i++) {
            var spriteName = symbols[i]['spriteName'];

            var animBlinkSymb = new AnimBlink(spriteName, 5, duration);

            animBlinkSymb.run().then(function() {
                resolve();
            });
        }
    });
}

export function anim_freesin_show(win_set, fsSkipping)
{
    madnes_set_visible("logo", false);
    madnes_set_visible("logo_anim", true);
    madnes_set_pos("logo_anim", wi / 2, 6);
    madnes_set_scale("logo_anim", 1, 1);

    var symbols = get_symbols_from_winset(win_set);
    var winsetLine = win_set.line;

    anim_add_frames(symbols, winsetLine).then(function() {
        return anim_set_tmp_symbols(symbols);
    }).then(function() {
        return anim_scale_symbols("in", symbols, 1.2, 1.2, 200, 0);
    }).then(function() {
        return anim_scale_symbols("out", symbols, 1, 1, 200, 1000);
    }).then(function() {

        anim_hide_tmp_symbols(symbols);
        anim_remove_frames(symbols, winsetLine);

        return new Promise(function(resolve) {
            madnes_anim_add_oncomplete_once("logo_anim", function() {
                resolve();
            });

            madnes_anim_play("logo_anim", "anim");
        });

    }).then(function() {

        return anim_fs_logo(200);

    }).then(function() {

        madnes_set_visible("freespins_text", true);
        madnes_set_visible("freespins_text_label", true);

        var fs_total = 0;
        if(fsSkipping) {
            fs_total = fsTotal;
        }

        madnes_set_text("freespins_text", freespins.getRoundNumber() + "/" + fs_total);

        return new Promise(function(resolve) {

            setTimeout(function() {
                resolve();
            }, 800);
        });

    }).then(function() {

        if(fsSkipping) {
            madnes_set_win(freespins.getResultWin());

            return Promise.resolve();
        } else {
            return anim_add_fs();
        }

    }).then(function() {
        return fade_in_reels_bg();
    }).then(function() {
        control_freespins();
    });
}

export function anim_freespin_hide()
{
    return new Promise(function(resolve) {

        fade_out_reels_bg();

        madnes_set_visible("freespins_text_label", false);
        madnes_set_visible("freespins_text", false);

        var scaleLogo = new AnimScale('logo_anim', 1, 1, 400);
        scaleLogo.run().then(function() {
            madnes_set_visible("logo_anim", false);
            madnes_set_visible("logo", true);
            madnes_set_text("freespins_text", "0/0");
            resolve();
        });
    });
}

function anim_fs_logo(duration)
{
    return new Promise(function(resolve) {
        var scaleLogo = new AnimScale('logo_anim', 0.76, 0.76, duration);
        scaleLogo.run().then(resolve);
    });
}

/**
 * @param {number} won
 * @returns {Promise}
 */
export function anims_money_add_win_anim(won)
{
    return new Promise(function (res) {

        madnes_show_money(madnes_money_to_coin(won), res);

    });
}

/**
 * @constructor
 * @param {number} win
 * @param {number} bet
 * @param {Array} winCoefs
 * @returns {BigWinCounter}
 */
function BigWinCounter(win, bet, winCoefs)
{
    this._bigWinValue = winCoefs[0];
    this._megaWinValue = winCoefs[1];
    this._superWinValue = winCoefs[2];

    this._onUpdate = function(val) {};
    this._onBigWin = function(val) {};
    this._onMegaWin = function(val) {};
    this._onSuperWin = function(val) {};

    this._win = win;
    this._bet = bet;

    /** @type {number} */
    this._intervalTicker;

    this.renderer = this._update.bind(this);

    /** @type {Function} */
    this.resolver;
}

BigWinCounter.prototype.init = function() {
    this._currVal = 0;
    this._step = 0.05;

    this._bigWinFired = false;
    this._megaWinFired = false;
    this._superWinFired = false;
};

BigWinCounter.prototype._getType = function() {

    var type = "bigwin";
    if(this._currVal >= this._superWinValue) {
        type = "superwin";
    } else if (this._currVal >= this._megaWinValue) {
        type = "megawin";
    }

    return type;
};

BigWinCounter.prototype._update = function() {
    var type = this._getType();

    switch (type) {
        case "bigwin":
            this._currVal = (this._megaWinValue / 2.7) * this._step;

            if(!this._bigWinFired) {
                this._bigWinFired = true;
                this._onBigWin(this._currVal);
            }

            break;
        case "megawin":
            this._currVal = (
                ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp((this._step -(2.0*2.7)) * 0.1) +
                ((this._step - 2.7) / 2.7 - 1.0) *
                ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp(-2.7 * 0.1) +
                (this._megaWinValue / this._bet)
            ) * this._bet;

            if(!this._megaWinFired) {
                this._megaWinFired = true;
                this._onMegaWin(this._currVal);
            }


            break;
        case "superwin":
            this._currVal = (
                ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp((this._step -(2.0 * 2.7))) +
                ((this._step - 2.7) / 2.7 - 1.0) *
                ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp(2.7) +
                (this._megaWinValue / this._bet)
            ) * this._bet;

            if(!this._superWinFired) {
                this._superWinFired = true;
                this._onSuperWin(this._currVal);
            }

            break;
    }

    if(this._currVal < this._win) {
        this._onUpdate(this._currVal /*, this._getType()*/);
        this._step += 0.05;
    } else {
        this._onUpdate(this._win);
        this._end();
    }
};

BigWinCounter.prototype._end = function() {
    //madnes_rem_from_render(this.renderer);
    clearInterval(this._intervalTicker);
    this.resolver && this.resolver();
    this.resolver = null;
};

BigWinCounter.prototype.run = function() {
    var _this = this;

    this.init();

    return new Promise(function(res) {
        _this.resolver = res;

        _this._intervalTicker = setInterval(_this.renderer, 1000 / fps);

        //madnes_add_to_render(_this.renderer);

    });
};

BigWinCounter.prototype.onUpdate = function(func) {
    this._onUpdate = func;
};

BigWinCounter.prototype.onBigWin = function(func) {
    this._onBigWin = func;
};

BigWinCounter.prototype.onMegaWin = function(func) {
    this._onMegaWin = func;
};

BigWinCounter.prototype.onSuperWin = function(func) {
    this._onSuperWin = func;
};